import projectDefaultEventsComponent from './project-default-events.component';

const projectDefaultEventsModule = angular.module('projectDefaultEvents', [
])
  .component('projectDefaultEvents', projectDefaultEventsComponent)
  .name;

export default projectDefaultEventsModule;
